/*
  Common mixin for any custom QItem containers to ensure all base props are consistent between them all
 */
export default {
  props: {
    clickable: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    activeClass: {
      type: String
    },
    tag: {
      type: String
    },
    dark: {
      type: Boolean
    },
    insetLevel: {
      type: Number
    },
    tabindex: {
      type: [String, Number]
    },
    manualFocus: {
      type: Boolean
    },
    focused: {
      type: Boolean
    }
  },
  emits: ['click']
}
